import React from 'react';
import ActivosAsegurado from './index';

export default function EquipoTransporte() {
    return (<ActivosAsegurado cClasif={'Camiones y Chasis'} cTitulo ={'Camiones y Chasis'} />);
}
